import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function SubItemRow({ item }) {
  return (
    <Link
      to={item.path}
      data-testid={`module-landing-item-${item.label.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
      className="group flex items-center justify-between py-3 border-b hairline-soft hover:border-foreground/40 transition-colors"
    >
      <div className="flex items-center gap-3">
        <item.icon size={14} className="ink-subtle"/>
        <span className="text-[12px] uppercase tracking-[0.24em] font-semibold ink">{item.label}</span>
      </div>
      <ArrowUpRight size={13} className="ink-subtle opacity-40 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"/>
    </Link>
  );
}

export function MetricCard({ item, num }) {
  return (
    <Link
      to={item.path}
      data-testid={`module-metric-${item.label.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
      className="group block rounded-lg border hairline surface-card p-5 lift-hover hover:border-foreground/40 transition-all"
    >
      <div className="flex items-start justify-between">
        <div className="h-10 w-10 rounded-md grid place-items-center border hairline surface-2">
          <item.icon size={16} className="ink"/>
        </div>
        <span className="section-num">.{String(num).padStart(2, "0")}</span>
      </div>
      <div className="mt-6">
        <div className="text-[9px] uppercase tracking-[0.24em] font-semibold ink-subtle">Workspace</div>
        <div className="mt-1 display-heading text-lg ink uppercase leading-tight">{item.label}</div>
      </div>
      <div className="mt-4 pt-3 border-t hairline-soft flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-wider font-semibold ink-subtle">Open</span>
        <ArrowUpRight size={13} className="ink-subtle opacity-40 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"/>
      </div>
    </Link>
  );
}
